import React, { useState, useEffect } from "react";
import "./Clients.css";
import Pagination from "react-js-pagination";
import Gbtn from "../../../Components/buttons/Gbtn";
import DashNav from "../../../Components/DashNav/DashNav";
import EmployeeSVG from "../../../Components/SVGS/EmployeeSVG";
import { FiEdit } from "react-icons/fi";
import { getAllClients } from "../../../api";
import { RiSignalWifiErrorLine, RiDeleteBin6Line } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";
import noImage from "../../../Assests/avatar1.png";

function Roles() {
  const icon = () => {
    return <EmployeeSVG size="28" fill="#DF2F35" />;
  };

  const location = useLocation();
  const CurrPage =
    location.state && location.state ? location.state.page : null;

  const navigate = useNavigate("");
  const addOnclick = () => {
    navigate("/dashboard/clients/AddClient");
  };

  const [page, setPage] = useState(CurrPage !== null ? CurrPage : 1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [clients, setClients] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [paginationDisplay, setPaginationDisplay] = useState("block");
  const [err, setErr] = useState(false);
  const [searchString, setSearchString] = useState("");

  const arr = [
    {
      id: 4,
      image_path: "../../../Assests/profile2.jpeg",
      name: "hammad",
      link: "url/hhtp/dkenyx33%662df",
    },
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchRoles(page);
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchString.trim() !== "") fetchRoles(page, searchString);
    }, 1500);
    return () => {
      clearTimeout(delay);
    };
  }, [searchString]);

  const fetchRoles = (pageNumber, searchTxt) => {
    setisLoading(true);
    setErr(false);
    getAllClients(limit, pageNumber, searchTxt)
      .then(({ data }) => {
        setisLoading(false);
        if (data.success) {
          setClients(data.result);
          setTotalRecords(data.total_records);
          setPaginationDisplay("block");
          setPage(pageNumber);
        } else {
          if (data.error_code === 2) {
            setClients(data.result);
            setErrorMsg(data.message);
          } else {
            setErr(true);
            setErrorMsg(data.message);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setErr(true);
        setPaginationDisplay("none");
        setErrorMsg(`Network Error! ${err.message}`);
        setisLoading(false);
      });
  };

  const handlePageChange = (pageNumber) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (pageNumber >= 1) {
      fetchRoles(pageNumber, searchString);
    }
  };

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    if (e.target.value === "") {
      fetchRoles(page);
    }
  };

  return (
    <>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText="Clients" />
        </div>

        <div className="dashPanel border-lt-Gray">
          <div className="r-ViewBar">
            <div className="r-ViewBar2">
              <div>
                <input
                  type="search"
                  value={searchString}
                  onChange={handleSearch}
                  placeholder="Search"
                  className="rolesSearch"
                />
              </div>
            </div>
            <div className="r-View-btn">
              <Gbtn
                text="Add"
                color="#DF2F35"
                radius="5px"
                width="200px"
                func={addOnclick}
              />
            </div>
          </div>
          {isLoading ? (
            <LoadingSpinner />
          ) : err ? (
            <div className="network-err-msg">
              <RiSignalWifiErrorLine /> {errorMsg}
            </div>
          ) : clients && clients ? (
            <div className="tableContainer">
              <table className="roleViewTable">
                <thead>
                  <tr>
                    <th style={{ paddingRight: "70px", paddingLeft: "18px" }}>
                      Actions
                    </th>
                    <th>Photo</th>
                    <th>Link</th>
                  </tr>
                </thead>
                <tbody>
                  {clients.map((data) => (
                    <Rows data={data} currentPage={page} />
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="network-err-msg">{errorMsg}</div>
          )}
          <div className="paginationDiv" style={{ display: paginationDisplay }}>
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={3}
              onChange={(pageNumber) => {
                handlePageChange(pageNumber);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
const Rows = ({ data, currentPage }) => {
  const navigate = useNavigate();
  const editRole = () => {
    navigate("/dashboard/clients/editClient", {
      state: { clientToEdit: data, page: currentPage },
    });
  };
  const delRole = () => {
    navigate("/dashboard/clients/deleteClient", {
      state: { clientToEdit: data, page: currentPage },
    });
  };

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [imgErr, setImgErr] = useState(false);

  const handleImageErr = () => {
    setImgErr(true);
  };

  return (
    <>
      {data && data ? (
        <tr>
          <td
            style={{
              minWidth: "60px",
            }}
          >
            <div style={{ display: "flex", margin: "0 15px" }}>
              <button onClick={editRole} className="Actionbtn editBtn">
                <FiEdit />
              </button>
              <button onClick={delRole} className="Actionbtn delBtn">
                <RiDeleteBin6Line />
              </button>
            </div>
          </td>
          <td>
            <img
              src={imgErr ? noImage : baseUrl + data.image_path}
              onError={handleImageErr}
              alt=""
              height={"38"}
              width={"38"}
              style={{
                borderRadius: "100%",
                border: "1px solid lightgray",
                borderBlockColor: "lightgray",
              }}
            />
          </td>
          {/* <td>{data.name}</td> */}
          <td>{data.website_link}</td>
        </tr>
      ) : null}
    </>
  );
};

export default Roles;
